import { request } from '.';
import { Id } from 'src/utils/types';

export type CompanyDashboardTreinamentos = {
  total_disponiveis: number;
  total_realizados_empresa: number;
  percentual_conformidade: number;
  status_cor: 'vermelho' | 'amarelo' | 'verde' | string;
};

export type CompanyDashboardNR1 = {
  avaliacao: boolean;
  em_conformidade: boolean;
};

export type CompanyDashboardResumoFinanceiro = {
  sessoes_pendentes: number;
  valor_mensal_pendente: number;
  valor_mensal_consolidado: number;
  mensalidade_quitada: boolean;
};

export type CompanyDashboard = {
  empresa_id: number;
  empresa: string;
  periodo: { data_inicio: string; data_fim: string };
  atendimentos_totais_mes: number;
  colaboradores_total: number;
  colaboradores_ativos_mes: number;
  percentual_colaboradores_ativos_mes: number;
  treinamentos: CompanyDashboardTreinamentos;
  nr1: CompanyDashboardNR1;
  resumo_financeiro: CompanyDashboardResumoFinanceiro;
};

export type CompanyFinancialSummary = {
  empresa_id: number;
  empresa: string;
  periodo: { data_inicio: string; data_fim: string };
  sessoes_pendentes: number;
  valor_sessao: number;
  valor_mensal_pendente: number;
  valor_mensal_consolidado: number;
  mensalidade_quitada: boolean;
};

type DateParams = {
  data_inicio?: string;
  data_fim?: string;
};

export const getCompanyDashboard = async (
  empresaId: Id,
  params?: DateParams
): Promise<CompanyDashboard> => {
  const response = await request.get<CompanyDashboard>(
    `/empresas/${empresaId}/dashboard`,
    { params }
  );
  return response.data;
};

export const getCompanyFinancialSummary = async (
  empresaId: Id,
  params?: DateParams
): Promise<CompanyFinancialSummary> => {
  const response = await request.get<CompanyFinancialSummary>(
    `/empresas/${empresaId}/resumo-financeiro`,
    { params }
  );
  return response.data;
};

export const getTrainingComplianceColor = (
  statusCor?: string
): 'error' | 'warning' | 'success' | 'default' => {
  switch (statusCor?.toLowerCase()) {
    case 'vermelho': return 'error';
    case 'amarelo':  return 'warning';
    case 'verde':    return 'success';
    default:         return 'default';
  }
};
